export type CallTerminalOutcome =
  | 'declined'
  | 'cancelled'
  | 'missed'
  | 'busy'
  | 'failed'
  | 'completed';

export type CallParticipantRole = 'initiator' | 'receiver';

const initiatorWrittenOutcomes = new Set<CallTerminalOutcome>([
  'cancelled',
  'missed',
  'failed',
  'completed',
]);

export const isTerminalWriter = (
  outcome: CallTerminalOutcome,
  role: CallParticipantRole,
) =>
  initiatorWrittenOutcomes.has(outcome)
    ? role === 'initiator'
    : role === 'receiver';
